// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const TimelineFormFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
`;
